module.exports = __webpack_public_path__ + "img/2.86137068.jpg";